module.exports = __webpack_public_path__ + "img/anchor.426a6894.svg";